module.exports = __webpack_public_path__ + "media/images/nav/icon_9-04ff931cfa564788967f016c078f911f.svg";